"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const methods_1 = require("../methods");
const context_1 = __importDefault(require("../context/context"));
const useForm = () => {
    const context = (0, react_1.useContext)(context_1.default);
    return {
        fields: context.fields,
        errors: context.errors,
        setError: context.actions?.setError,
        clearError: context.actions?.clearError,
        clearAllErrors: context.actions?.clearAllErrors,
        setDefaultError: context.actions?.setDefaultError,
        setFieldValue: context.actions?.setFieldValue,
        setFieldOptions: context.actions?.setFieldOptions,
        handleSubmit: (callback) => (0, methods_1.handleSubmit)(callback, context),
        registerSchema: (schema) => (0, methods_1.registerSchema)(schema, context),
        register: (name, options) => (0, methods_1.register)(name, context, options),
    };
};
exports.default = useForm;
